import React, { FC, useContext, useState } from 'react';
import { DogSummary } from 'types/Dog';
import logo from 'assets/images/P4P_Logo-blue.gif';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from 'data/Provider';
import classNames from 'classnames';
import { DataContext } from 'hooks/HeaderContext';


interface IDogCardProps {
    dog: DogSummary;
}


const DogCard: FC<IDogCardProps> = ({
    dog,
}) => {

    const {
        filteredDogsList: dogList,
        setSelectedDogIndex,
    } = useContext(DataContext);

    const [imageLoaded, setImageLoaded] = useState(false);
    const navigate = useNavigate();

    const retrieveDogDetail = (id: number) => {
        setSelectedDogIndex(dogList.findIndex(d => d.id === id));
        navigate('dog/detail/' + id);
    }

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    return (
        <>
            <div className="col-6 col-md-4 col-lg-3 dog-bio" data-ref-id={dog.id} >
                <div className={classNames("dog-card card shadow p-0"
                )} onClick={() => retrieveDogDetail(dog.id)}>
                    <div className={classNames("dog", { "placeholder-wave h-100 w-100": !imageLoaded })}>
                        <div className={classNames("pic imageLinks", { 'placeholder h-100 w-100': !imageLoaded })} role="button">
                            <img className="img-fluid"
                                src={dog.photoId ? (BASE_URL + '/photos/' + dog.photoId) : logo}
                                style={!dog.photoId ? { objectFit: 'contain', opacity: '0.5' } : null}
                                loading='lazy'
                                onLoad={handleImageLoad}
                                alt={imageLoaded && dog.photoId ? `Photo of dog ${dog.name}` : `Stock image used for ${dog.id}`} />

                        </div>
                        <div className="dogCard-body">
                            {imageLoaded
                                ?
                                <>
                                    <div className="dog-name"><button>{dog.name}</button></div>
                                    <div className="text-truncate mt-1">
                                        {dog.breed}
                                    </div>
                                </>
                                :
                                <p className="card-text placeholder-wave">
                                    <span className="placeholder col-7"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-4"></span>

                                </p>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default DogCard;




















